Customer.Reports ||= {}

class Customer.Reports.ExportModalView extends Backbone.View
  template: JST['backbone/templates/customer/reports/export_modal']

  initialize: (@options = {}) ->
    @contentAmount = @options.contentAmount
    @estimatedTime = @_huminizedEstimatedTime() if @estimatedTimeExists()
    @timeout = @options.timeout || false

  render: ->
    @$el.html @template
      contentAmount: @contentAmount
      estimatedTime: @estimatedTime
      timeout: @timeout
    @

  show: ->
    @$el.find('#export-modal').modal()

  estimatedTimeExists: =>
    @options.estimatedTime != undefined && @options.estimatedTime >= 0

  _huminizedEstimatedTime: ->
    result = moment.duration(@options.estimatedTime, 'seconds').humanize()
    result = 'unos ' + result if result == 'segundos'
    result
